import React from 'react';
import SvgNormalizer from '@asphalt-react/svg-normalizer';
import PropTypes from 'prop-types';
import { svgUtil } from '@asphalt-react/helper';

const {
  isSVG
} = svgUtil;
const Qualifier = ({
  children,
  iconSize
}) => {
  const isTextQualifier = typeof children === "string";

  if (isTextQualifier) {
    return children;
  }

  if (!isSVG(children)) {
    console.warn("Qualifier can only be SVG");
    return null;
  }

  return /*#__PURE__*/React.createElement(SvgNormalizer, {
    size: iconSize
  }, children);
};
Qualifier.propTypes = {
  /**
   * Qualifier to render. Accepts SVG for icon and string.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,

  /**
   * Size of the icon qualifier.
   */
  iconSize: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  })
};
Qualifier.defaultProps = {
  iconSize: {
    width: "16",
    height: "16"
  }
};

export { Qualifier };
